"use client";

import { FC } from "react";

import { IStoryBlokKlaviyoFormSection } from "../SectionKlaviyoForm.types";

const SectionKlaviyoFormSection: FC<IStoryBlokKlaviyoFormSection> = (props) => (
  <div data-component={ SectionKlaviyoFormSection.name } >
    <div className={`klaviyo-form-${props.formId}`}></div>
  </div>
);

export default SectionKlaviyoFormSection;
